import { Reveal } from "@/components/site/Reveal";
import { SignalQuiz } from "@/components/site/SignalQuiz";

export const QuizSection = () => (
  <section id="quiz" data-testid="quiz-section" className="border-t border-line bg-[#080808]">
    <div className="mx-auto grid max-w-7xl gap-14 px-6 py-24 md:px-12 md:py-36 lg:grid-cols-12">
      <Reveal className="lg:col-span-4">
        <p className="eyebrow">60-second quiz</p>
        <h2 className="font-display mt-5 text-4xl font-medium leading-tight tracking-tight text-white md:text-5xl">
          Do you follow the noise <span className="font-serif-i text-zinc-400">or the signal?</span>
        </h2>
        <p className="mt-6 text-zinc-300">Five quick questions. Find out where you stand and which part of the Blueprint helps you most.</p>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-8"><SignalQuiz /></Reveal>
    </div>
  </section>
);
